import { getWeekAfterStartDate, getNearestSunday } from './getNearestDates';

export const weeksBetween = (startDate: Date, endDate: Date) => {
  var diff = (endDate.getTime() - startDate.getTime()) / 1000;
  diff /= 60 * 60 * 24 * 7;
  return Math.abs(Math.ceil(diff));
};

export const weeksCount = (startDate: Date, endDate: Date, weekFormat: string) => {
  let date = new Date(startDate);
  let count = 0;
  if (weekFormat === 'weekly') {
    while (date.getTime() <= new Date(endDate).getTime()) {
      count++;
      date = getWeekAfterStartDate(date);
      date = new Date(date);
      date = new Date(date.setDate(date.getDate() + 1));
    }
  }
  if (weekFormat === 'mondayToSunday') {
    while (new Date(date).getTime() <= new Date(endDate).getTime()) {
      count++;
      date = JSON.parse(JSON.stringify(getNearestSunday(date)));
      date = new Date(date);
      date = new Date(date.setDate(date.getDate() + 1));
    }
  }
  return count;
};
